import React from "react";

const MenuChucNang = ({ RoleThemMoi, btnThemMoiClick }) => (
    <div className="search-new">
        <div
            className="input-sm-new"
            onClick={btnThemMoiClick}
            style={{ width: "12%", display: RoleThemMoi ? "block" : "none" }}
        >
            <button className="btn btn-border-new">
                <img
                    src="/app-assets/images/icon-them-moi-cam-do.png"
                    className="icon-button-v2"
                    alt="Thêm mới"
                />
                <span>Thêm mới</span>
            </button>
        </div>
    </div>
);

export default MenuChucNang;
